import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { FooterModule } from '../footer/footer.module';
import { WindowService } from '../shared/window.service';
import { ContactUsPictureComponent } from './contact-us-picture/contact-us-picture.component';
import { ContactUsProfileComponent } from './contact-us-profile/contact-us-profile.component';
import { FaqContainerComponent } from './faq-container/faq-container.component';
import { ContactUsFaqsComponent } from './contact-us-page-faqs/contact-us-faqs.component';
import { ContactUsLinksComponent } from './contact-us-links/contact-us-links.component';
import { ContactUsComponent } from './contact-us.component';
import { HeaderModule } from '../header/header.module';

@NgModule({
  imports: [CommonModule, SharedModule, FooterModule, HeaderModule],
  declarations: [
    ContactUsPictureComponent,
    ContactUsProfileComponent,
    FaqContainerComponent,
    ContactUsFaqsComponent,
    ContactUsLinksComponent,
    ContactUsComponent,
  ],
  providers: [WindowService],
})
export class ContactUsModule {}



// WEBPACK FOOTER //
// ./ts/app/contact-us/contact-us.module.ts